const chevron = "//www.angulus.dk/cdn/shop/t/27/assets/chevron.svg?v=104653405973261378481728370233"
const readMore = "Læs mere";
const readLess = "Læs mindre";
const HEIGHT_THRESHOLD_PX = 200;

const richText = document.querySelector('.rich-text');
const innerText = richText.querySelector('.rich-text__inner');
const textHeight = innerText.scrollHeight;
const hasTextOverflow = textHeight > HEIGHT_THRESHOLD_PX;

if (hasTextOverflow) {
    innerText.classList.add('collapsed');
    innerText.style.setProperty('--rich-text-height', `${HEIGHT_THRESHOLD_PX}px`);

    const readMoreButton = document.createElement('button');
    const icon = document.createElement('img');
    const text = document.createElement('span');

    readMoreButton.classList.add('rich-text__read-more');
    text.textContent = readMore;
    icon.src = chevron;

    readMoreButton.appendChild(text);
    readMoreButton.appendChild(icon);
    richText.appendChild(readMoreButton);
    readMoreButton.addEventListener('click', () => toggleReadMore(readMoreButton));
}

function toggleReadMore(target) {
    const text = target.querySelector('span');
    innerText.classList.toggle('collapsed');
    innerText.style.setProperty('--rich-text-height', innerText.classList.contains('collapsed') ? `${HEIGHT_THRESHOLD_PX}px` : `${textHeight}px`);
    text.textContent = innerText.classList.contains('collapsed') ? readMore : readLess;
}
